import React from 'react'
import { Button, Card, Typography } from 'antd'
import { Link, useLocation, useNavigate } from 'react-router-dom'

export default function OrderSuccess() {
  const { state } = useLocation()
  const orderId = state?.orderId
  const navigate = useNavigate()

  return (
    <div style={{ display: 'grid', gap: 16 }}>
      <Typography.Title level={3} style={{ margin: 0 }}>تم إرسال الطلب بنجاح</Typography.Title>
      <Card>
        <div style={{ display: 'grid', gap: 12 }}>
          <Typography.Paragraph style={{ margin: 0 }}>
            شكراً لطلبك! {orderId ? (<><br/>رقم طلبك هو: <strong>#{orderId}</strong></>) : null}
          </Typography.Paragraph>
          <div style={{ display: 'flex', gap: 8 }}>
            <Link to="/categories">تصفح المتاجر لطلب جديد</Link>
          </div>
        </div>
      </Card>
    </div>
  )
}
